import React from 'react'
import {Route,Switch} from 'react-router-dom'
import asyncComponent from "../../../util/asyncComponent";
const FIS_ClosingAndOthers =({match})=>(
    <Switch>
          <Route  path={`${match.url}/FileGenerator`} component={asyncComponent(()=>import( './FileGenerator/index'))} />
    </Switch>
)
export default FIS_ClosingAndOthers;